export const ItemStatusEnum = {
  ITEMS_QUALIFIED: 'ItemsQualified',
  ITEMS_DISQUALIFIED: 'ItemsDisqualified',
};

export const ItemStatusTextEnum = {
  ITEM_TOBE_ORDERED: 'ORDER TYPE: ITEM TO BE ORDERED',
  ITEM_NOT_NEEDED: 'ORDER TYPE: ITEM NOT NEEDED',
  ITEM_CANNOT_BE_ORDERED: 'ORDER TYPE: ITEM CANNOT TO BE ORDERED BY SITE',
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/Consolidate.js